import { AbacoVuexModule, State } from "@abaco/web-common/src/app";

export default class FerreroDashboardVuexModule extends AbacoVuexModule {
    @State() provinces!: any;
    @State() selectedProvince!: any;
    @State() referenceAreaNavBarFilterOpen!: boolean;
    @State() reloadTrigger!: number;
}

